import axios from 'axios';

export const api = axios.create({
  baseURL: window.APP_BASE_URL
});


export const sca = axios.create({
  baseURL: window.APP_AUTHORITY
});
